module.exports = "//public.getcloudapp.com/packs/media/images/annotate/draw-e22ede210977a393662a998063d4986a.svg";